import { AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import React from 'react';

export function useCustomWidth<
	VT extends AntSelectValue,
	OptionType extends BaseOptionType,
	P extends Pick<AntSelectPropsGeneric<VT, OptionType>, 'width' | 'style'>,
>(props: P) {
	const { width, style, ...rest } = props;

	const styleActual = React.useMemo(() => {
		const result = { ...(style ?? {}) };

		if (width != null) {
			result.width = width + 'px';
		}

		return result;
	}, [style, width]);

	return {
		style: styleActual,
		...rest,
	};
}
